import ThemeToggle from "@/components/ThemeToggle";
// import ChatBotWidget from "@/components/ChatBotWidget";
// import useAuth from "@/hooks/stores/useAuth";

/**
 * Bottom-right stacked FABs (theme + optional chat) so they never overlap.
 */
export default function FloatingCornerActions() {
  // const { userRole } = useAuth();
  // Hidden on candidate portal — re-enable when chat bot should be visible again
  // const showChat = userRole?.toLowerCase() === "candidate";
  // const showChat = false;
//return null
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col-reverse items-end gap-3 pointer-events-none">
      <div className="pointer-events-auto">
        <ThemeToggle />
      </div>
      {/* Candidate portal chat bot — hidden for now
      {showChat && (
        <div className="pointer-events-auto">
          <ChatBotWidget />
        </div>
      )}
      */}
    </div>
  );
}
